import type { LookoRouteObject } from '../LookoRouteObject';
import { Cafe24MasterAuthGuardWrap } from '../auth/AuthGuardWrap';

export const 월별_결제_내역_다운로드_라우터 = {
  cafe24: {
    path: '/download/cafe24',
    async lazy() {
      const { default: Page } = await import('@/router/cafe24-master-account/Cafe24MasterPage');
      return {
        Component: Cafe24MasterAuthGuardWrap(Page),
      };
    },
    handle: {
      title: '월별 결제 내역',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,
};
